import api from './api';
import {
  WidgetTemplate,
  WidgetType,
  CreateWidgetTemplateRequest,
  UpdateWidgetTemplateRequest,
  PaginatedResponse,
} from '../types';

export interface WidgetFilters {
  search?: string;
  dashboardId?: string;
  workflowId?: string;
  widgetType?: WidgetType;
}

export const widgetService = {
  getWidgetTemplates: async (
    page = 1,
    pageSize = 10,
    filters?: WidgetFilters
  ): Promise<PaginatedResponse<WidgetTemplate>> => {
    // Backend expects snake_case query params
    const params: Record<string, unknown> = { page, page_size: pageSize };
    if (filters?.widgetType) params.widget_type = filters.widgetType;
    if (filters?.search) params.search = filters.search;
    if (filters?.dashboardId) params.dashboard_id = filters.dashboardId;
    if (filters?.workflowId) params.workflow_id = filters.workflowId;

    const response = await api.get<PaginatedResponse<WidgetTemplate>>('/widgets', {
      params,
    });
    return response.data;
  },

  getWidgetTemplate: async (id: string): Promise<WidgetTemplate> => {
    const response = await api.get<WidgetTemplate>(`/widgets/${id}`);
    return response.data;
  },

  createWidgetTemplate: async (data: CreateWidgetTemplateRequest): Promise<WidgetTemplate> => {
    const response = await api.post<WidgetTemplate>('/widgets', data);
    return response.data;
  },

  updateWidgetTemplate: async (
    id: string,
    data: UpdateWidgetTemplateRequest
  ): Promise<WidgetTemplate> => {
    const response = await api.put<WidgetTemplate>(`/widgets/${id}`, data);
    return response.data;
  },

  deleteWidgetTemplate: async (id: string): Promise<void> => {
    await api.delete(`/widgets/${id}`);
  },

  duplicateWidgetTemplate: async (id: string): Promise<WidgetTemplate> => {
    const response = await api.post<WidgetTemplate>(`/widgets/${id}/duplicate`);
    return response.data;
  },
};
